import { render, staticRenderFns } from "./AiTags.vue?vue&type=template&id=568c6bd1&scoped=true"
import script from "./AiTags.vue?vue&type=script&lang=js"
export * from "./AiTags.vue?vue&type=script&lang=js"
import style0 from "./AiTags.vue?vue&type=style&index=0&id=568c6bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c6bd1",
  null
  
)

export default component.exports